import React from 'react'

import { useTranslation } from '@common/hooks/translation';
import './style.scss';

export const DepositPendingPopup = ({
  type,
  closePopup
}) => {
  const t = useTranslation();
  return (
    <div className={`popup-content popup-small deposit-pending-popup ${type}`}>
      <i onClick={closePopup} className="global-icon icon-Close close-popup" />
      <h3 className="popup-title">{t(`Pending ${type}`)}</h3>
      <p className='popup-subtitle'>{t('Check your phone to approve the transaction')}</p>
      <div className="popup-main-content">
        <i className='global-icon icon-payment-pending' />
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-confirm-button"
          onClick={closePopup}
        >
          {t('Ok')}
        </button>
      </div>
    </div>
  )
}